import ConsultedSourcesModal from './consultedSourcesModal'

export default ConsultedSourcesModal
